import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { motion } from 'framer-motion';
import { Award, BookOpen } from 'lucide-react';

export const FacultyCard = ({ faculty, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Card className="h-full overflow-hidden border-2 hover:border-primary transition-all duration-300 hover:shadow-xl group">
        {/* Image */}
        <div className="relative overflow-hidden bg-muted">
          <img
            src={faculty.image}
            alt={faculty.name}
            className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
          />
        </div>

        <CardContent className="p-6">
          {/* Name & Designation */}
          <div className="mb-4">
            <h3 className="text-xl font-heading font-bold text-foreground mb-1">
              {faculty.name}
            </h3>
            <p className="text-sm text-secondary font-semibold">
              {faculty.designation}
            </p>
          </div>

          {/* Qualification & Experience */}
          <div className="space-y-2 mb-4">
            <div className="flex items-start space-x-2">
              <BookOpen className="h-4 w-4 text-primary mt-1 flex-shrink-0" />
              <span className="text-sm text-foreground">{faculty.qualification}</span>
            </div>
            <div className="flex items-start space-x-2">
              <Award className="h-4 w-4 text-secondary mt-1 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">{faculty.experience} Experience</span>
            </div>
          </div>

          {/* Specialization */}
          <Badge className="mb-4 bg-primary/10 text-primary hover:bg-primary/20 border-primary/20">
            {faculty.specialization}
          </Badge>

          {/* Achievements */}
          <div className="space-y-2">
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
              Key Achievements
            </p>
            <ul className="space-y-1.5">
              {faculty.achievements.map((achievement, idx) => (
                <li key={idx} className="text-sm text-foreground flex items-start">
                  <span className="text-secondary mr-2 flex-shrink-0">•</span>
                  <span>{achievement}</span>
                </li>
              ))}
            </ul>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
